import React, { useState } from 'react';
import theme from './ToggleNumberInput.module.scss';
import { Input, classnames } from '@ygtechnologies/bygr-frontend-component-library';
import { Checkbox } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';

export interface TestProps {
    value: number;
    disabled?: boolean;
    onChange(newValue: number): void;
}

export const ToggleNumberInput: React.FC<TestProps> = ({ value, disabled = false, onChange }) => {
    const [enabled, setEnabled] = useState(value !== 0);
    return (
        <div className={theme.numberAndTextContainer}>
            <Checkbox
                disabled={disabled}
                inputSize="md"
                checked={enabled}
                onChange={(e) => {
                    e.target.checked;
                    setEnabled(e.target.checked);
                    if (!e.target.checked) {
                        onChange(0);
                    } else {
                        onChange(1);
                    }
                }}
            />
            <div className={theme.dayContainer}>
                <Input
                    value={enabled ? value : ''}
                    type="number"
                    onChange={(event) => onChange(+event.target.value)}
                    disabled={!enabled || disabled}
                    className={classnames('form-control', theme.inputBox)}
                />
                {value !== 1 ? <Trans>Days</Trans> : <Trans>Day</Trans>}
            </div>
        </div>
    );
};
